/*
  Cookie banner — "read more" disclosure.

  Why this exists: Shopify owns the consent banner DOM and supplies the copy.
  Where the merchant has entered short copy the paragraph is two lines and this
  script does nothing. Where the locale still carries Shopify's default the
  paragraph runs eight or nine lines and the notice becomes a wall of legal
  text in front of someone who is just browsing.

  It collapses the paragraph to a few lines and adds a real <button> to expand
  and re-collapse it. Deliberately a button and not a CSS mask: the text has to
  be reachable at the moment of deciding, by keyboard as well as pointer, and
  the control has to be visible rather than an invisible scroll region.

  It only ever acts when the text genuinely overflows, so it self-disables once
  every locale carries the short copy.
*/
(function () {
  'use strict';

  var S = window.aycanCookieStrings || {};
  var MORE = S.more || 'Read more';
  var LESS = S.less || 'Show less';

  function enhance(banner) {
    var body = banner.querySelector('.shopify-pc__banner__body');
    var p = body && body.querySelector('p');
    if (!p || p.dataset.aycanExpandReady) return;
    p.dataset.aycanExpandReady = '1';

    // Everything below is a text measurement, so it has to wait for the web
    // fonts. Measuring against the fallback font gave different line counts
    // run to run — /ar came out 209px with no button on one load and 217px
    // with one on the next, purely from font timing.
    if (document.fonts && document.fonts.status !== 'loaded') {
      document.fonts.ready.then(function () {
        measure(body, p);
      });
      return;
    }
    measure(body, p);
  }

  function measure(body, p) {
    // Clamp first, then measure how much that actually hid. The clamp height
    // lives in the stylesheet; reading the result back keeps the two in step
    // instead of duplicating the line count here.
    body.classList.add('aycan-cookie-collapsible');

    var hidden = p.scrollHeight - p.clientHeight;
    var line = parseFloat(getComputedStyle(p).lineHeight) || 21;

    // The control is only worth its own height when it hides appreciably more
    // than it costs. The button plus its margin measures ~29px, so hiding one
    // line (21px) makes the panel TALLER — /ar went 209 -> 217 — and hiding
    // two nets barely 14px, which is not worth putting a control in front of
    // a consent notice. Three lines up, it is a clear win.
    //
    // Rounded to whole lines on purpose: /de hides 64px against a 21.45px line
    // box, i.e. 2.98 lines, and a raw `hidden < line * 3` threw out the one
    // locale this was built for by a third of a pixel.
    if (Math.round(hidden / line) < 3) {
      body.classList.remove('aycan-cookie-collapsible');
      return;
    }

    var btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'aycan-cookie-more';
    btn.setAttribute('aria-expanded', 'false');
    btn.setAttribute('aria-controls', p.id || (p.id = 'aycan-cookie-copy'));
    btn.textContent = MORE;

    btn.addEventListener('click', function () {
      var expanded = body.classList.toggle('is-expanded');
      btn.setAttribute('aria-expanded', expanded ? 'true' : 'false');
      btn.textContent = expanded ? LESS : MORE;
    });

    body.appendChild(btn);
  }

  function scan() {
    var banner = document.getElementById('shopify-pc__banner');
    if (banner) enhance(banner);
  }

  // The banner is injected asynchronously by Shopify's consent script, and can
  // be injected again later (e.g. after "Manage preferences" is dismissed), so
  // watch rather than run once. The dataset guard above keeps it idempotent.
  if (document.readyState !== 'loading') scan();
  document.addEventListener('DOMContentLoaded', scan);

  if (window.MutationObserver) {
    new MutationObserver(scan).observe(document.body, {
      childList: true,
      subtree: false,
    });
  }
})();
